module.exports = __webpack_public_path__ + "assets/img/title-5a585d31.png";